
/*
静态方法调用
 */
import axios from 'axios'
// import './../style/loading.less'
// import Util from "../utils/utils";
import CryptoJS from "crypto-js";
export default class Axios {
    //加密
    static crypstrFun(strparams, key) {
        let aesstrparas =
            CryptoJS.AES.encrypt(strparams, key, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }).ciphertext.toString();
        return aesstrparas;
    }
    static ajax(option) {
        let loading;
        /*  if (option.data&&option.isShowLoading!==false){
              loading = document.getElementById('ajaxLoading')  ;
              loading.style.display='block'  ;
          }*/
        let baseurl = 'http://0.0.0.0:7300/mock/5e63594a7a1f602aa6dcb1f0/bocim_hkapi';
        return new Promise(
            (resolve, reject) => {
                axios({
                    url: option.url,
                    method: 'get',
                    baseURL: baseurl,
                    timeout: 5000,
                    params: (option.data && option.data.params) || ''
                }).then((response) => {
                    /*   if (option.data&&option.isShowLoading!==false){
                           loading = document.getElementById('ajaxLoading')  ;
                           loading.style.display='none'  ;
                       }*/
                    if (response.status == '200') {
                        let res = response.data;
                        if (res.code == '0') {
                            resolve(res);
                        } else {
                            console.info("请求返回失败")
                        }
                    } else {
                        reject(response.data);
                    }
                })
            }
        )
    }
    static ajaxAESETF(options) {
        return new Promise((resolve, reject) => {

            axios(
                {
                    url: '/active-service/HK-BOCIM/publickey',
                    method: 'post',
                    baseURL: '',
                    timeout: 100000,
                    // headers:{'Content-type':'application/json',},
                }
            ).then((response1) => {
                if (response1.status == '200') {
                    let loading;
                    let baseUrl = '';
                    const key = CryptoJS.enc.Utf8.parse(response1.data.data.publicKey);
                    let strparams = JSON.stringify(options.data.params);
                    // let baseUrl='http://localhost:7300/mock/5dd10fcb4df5892340655ad5'
                    let testcryostr = this.crypstrFun(strparams, key)
                    console.log(testcryostr);
                    axios({
                        url: options.url,
                        method: 'post',
                        baseURL: baseUrl,
                        timeout: 100000,
                        // data:options.data.params
                        headers: { 'Content-type': 'application/json', },
                        // headers:{'Content-type':'application/x-www-form-urlencoded',},
                        data: testcryostr
                        // '82adbae60c38d03dd646eb447a2ac42315c86a9cf6ef8dc613dbac92e73771088d4c3318750b5a064d163402167f9dfeec52d10e0a5c5f88b99ca6b0d931966dee8e3745a9d8325c5b102a6ae47973fc81450bea8efa87f3ad34ba706cf4d19d682e530ab0f95686d0e4bdb28bfa7cc27878589072560e13711a380d3da501b3208616962d11b023eaa73fb55641e3d4e72cad440b34e5b88020a74738b0144851d0836983aa122880a342f6d97ea02ee2fbfb0a71d95bf03e2c2ae0d9146be9d93959cb611f8e1f0877421ffecd6a3f'
                    }
                    ).then((response) => {
                        if (response.status == '200') {
                            // let res  = response.data  ;

                            const oldHexStr = CryptoJS.enc.Hex.parse(response.data);
                            // 将密文转为Base64的字符串
                            const base64Str = CryptoJS.enc.Base64.stringify(oldHexStr);

                            let resstr = CryptoJS.AES.decrypt(base64Str, key, {
                                mode: CryptoJS.mode.ECB,
                                padding: CryptoJS.pad.Pkcs7
                            }).toString(CryptoJS.enc.Utf8);

                            try {
                                let res = JSON.parse(resstr);

                                if (res.code == '0000' || res.code == '9999') {
                                    resolve(res);
                                } else {
                                    console.info(res.msg + 'error!');

                                }
                            } catch (e) {
                                console.error(resstr, e, 'onError')
                            }

                        } else {
                            reject(response)
                        }
                    })


                }




            })

        });
    }



    static ajaxAESETF_bak(options) {
        let loading;
        let baseUrl = '';
        const key = CryptoJS.enc.Utf8.parse("");
        let strparams = JSON.stringify(options.data.params);
        // let baseUrl='http://localhost:7300/mock/5dd10fcb4df5892340655ad5'
        let testcryostr = this.crypstrFun(strparams, key)
        console.log(testcryostr);
        return new Promise((resolve, reject) => {
            axios({
                url: options.url,
                method: 'post',
                baseURL: baseUrl,
                timeout: 100000,
                // data:options.data.params
                headers: { 'Content-type': 'application/json', },
                // headers:{'Content-type':'application/x-www-form-urlencoded',},
                data: testcryostr
                // '82adbae60c38d03dd646eb447a2ac42315c86a9cf6ef8dc613dbac92e73771088d4c3318750b5a064d163402167f9dfeec52d10e0a5c5f88b99ca6b0d931966dee8e3745a9d8325c5b102a6ae47973fc81450bea8efa87f3ad34ba706cf4d19d682e530ab0f95686d0e4bdb28bfa7cc27878589072560e13711a380d3da501b3208616962d11b023eaa73fb55641e3d4e72cad440b34e5b88020a74738b0144851d0836983aa122880a342f6d97ea02ee2fbfb0a71d95bf03e2c2ae0d9146be9d93959cb611f8e1f0877421ffecd6a3f'
            }
            ).then((response) => {
                if (response.status == '200') {
                    // let res  = response.data  ;

                    const oldHexStr = CryptoJS.enc.Hex.parse(response.data);
                    // 将密文转为Base64的字符串
                    const base64Str = CryptoJS.enc.Base64.stringify(oldHexStr);

                    let resstr = CryptoJS.AES.decrypt(base64Str, key, {
                        mode: CryptoJS.mode.ECB,
                        padding: CryptoJS.pad.Pkcs7
                    }).toString(CryptoJS.enc.Utf8);
                    let res = JSON.parse(resstr);

                    if (res.code == '0000' || res.code == '9999') {
                        resolve(res);
                    } else {
                        console.info(res.msg + 'error!');

                    }

                } else {
                    reject(response)
                }
            })
        });
    }

}